import {post} from './api-calls';

export const checkAchievementDatabase = (id: string, type: string): Promise<any> => {
  // todo
  return post('/achievement', {userId: id, endpointSource: type});
};
